import React, { FC, useCallback, useContext } from 'react';
import AnimatedCard from '../../AnimatedCard';
import { observer } from 'mobx-react-lite';
import { NolPromotionStoreCtx } from '@/stores/NolPromotionStore';
import { getSVG } from '@/components/Common/styles/mixins';
import styles from './index.module.scss';

const TripleEventCard: FC = () => {
  const store = useContext(NolPromotionStoreCtx);
  const getResourcePath = useCallback((path: string): string => getSVG(`/static/images/nol-promotion/${path}`), []);
  return (
    <AnimatedCard
      className={styles.cardContainer}
      type={'white'}
      title={
        <div className={styles.title}>
          <img className={styles.logo} src={getResourcePath('v8/triple.png')} alt={'트리플'} />
          <br />
          NOL 카드 전용
          <br />
          <div className={styles.blue}>5% 할인쿠폰 2장</div>
        </div>
      }
      image={
        <img
          className={styles.image}
          src={getResourcePath('v7/v7_triple-event.png')}
          alt={'트리플 NOL 카드 전용 이벤트'}
        />
      }
      description={{
        normal: 'NOL 카드 페이에 NOL 카드를 등록한\n트리플 회원의 경우에 쿠폰 지급 및 이용 가능',
      }}
      onDetailClick={() => (store.isTripleDiscountCouponBottomSheetOpen = true)}
      logData={{
        object: '자세히 보기',
        objectType: 'Btn',
        objectContainer: '해외여행·공연·오프라인 혜택까지 NOL 카드 이벤트',
        motherPageVersion: store.version,
        motherPageSectionType: '이벤트',
        motherPageSectionName: '트리플 NOL 카드 전용 5% 쿠폰 2장',
        motherPageSectionNameSubTitle: '',
        deepLinkUri: '',
      }}
    />
  );
};

export default observer(TripleEventCard);
